import { Fragment } from 'react'

function escapeRegExp(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`)
}

export function HighlightMatch({ text, query }: Readonly<{ text: string, query: string }>) {
  const normalizedQuery = query.trim()
  if (!normalizedQuery) {
    return text
  }

  const matcher = new RegExp(`(${escapeRegExp(normalizedQuery)})`, 'gi')
  const parts = text.split(matcher)
  let keyPosition = 0

  return (
    <Fragment>
      {parts.map((part) => {
        keyPosition += part.length

        if (part.toLowerCase() === normalizedQuery.toLowerCase()) {
          return <strong key={`${keyPosition}-${part}`}>{part}</strong>
        }

        return <span key={`${keyPosition}-${part}`}>{part}</span>
      })}
    </Fragment>
  )
}
